import * as React from "react"
import { useRecoilState } from "recoil"
import { Link } from "@chakra-ui/react"
import { FullScreenIconProps } from "./buttons-main-screen.interface"
import { BiExitFullscreen } from "react-icons/bi"
import { FaExpand } from "react-icons/fa"
import { brandingSelector } from "../../../recoil/atoms/room"
import { useRecoilValue } from "recoil"
import { useFullScreenMobile } from "../../../hooks/useFullScreenMobile"
import { isBigPlayIconState } from "../../../recoil/atoms/bigPlayIcon"
import { useBrowserType } from "../../../hooks/useBrowserType"

const _FullScreenIcon: React.FC<FullScreenIconProps> = ({
  handleShowsFullScreen,
  isFullScreen,
  isFullScreenMobile,
  isMobile
}) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const { isIOS, isAndroidMobile, isSamsungBrowser } = useBrowserType()
  const [, setBigPlayIcon] = useRecoilState<boolean>(isBigPlayIconState)

  const toggleBigPlayButton = React.useCallback(() => {
    let timer = setTimeout(() => {
      setBigPlayIcon(true)
    }, 1000)
    return () => clearTimeout(timer)
  }, [setBigPlayIcon])

  const { handleFullScreenMobileWebCam } = useFullScreenMobile()

  const handleOnClick = React.useCallback(
    e => {
      e.stopPropagation()
      e.preventDefault()
      if (isFullScreenMobile) {
        if (isIOS) {
          toggleBigPlayButton()
        }
        handleFullScreenMobileWebCam()
      } else {
        handleShowsFullScreen()
      }
    },
    [
      isFullScreenMobile,
      isIOS,
      handleFullScreenMobileWebCam,
      toggleBigPlayButton,
      handleShowsFullScreen
    ]
  )

  return (
    <Link
      onClick={
        isAndroidMobile || isSamsungBrowser
          ? null
          : isFullScreenMobile
          ? e => {
              if (!isAndroidMobile) {
                toggleBigPlayButton()
              }
              handleFullScreenMobileWebCam()
            }
          : e => handleOnClick(e)
      }
      onTouchStart={
        isFullScreenMobile
          ? () => {
              if (!isAndroidMobile) {
                toggleBigPlayButton()
              }
              handleFullScreenMobileWebCam()
            }
          : handleShowsFullScreen
      }
      zIndex="1000"
      margin="0 auto"
      marginRight={isMobile && "4.8px"}
      id="FS"
      color={roomStyles?.overlayEmojiStrokeColor ?? "white"}
    >
      {isFullScreen ? (
        <BiExitFullscreen size="2.8rem" className="fs-icon" />
      ) : (
        <FaExpand size="2.8rem" className="fs-icon" />
      )}
    </Link>
  )
}

export const FullScreenIcon = _FullScreenIcon
